import { useEffect, useRef } from "react";

/*
 - help hook to keep track of 'providers' changes
 - how to ues: 
   - import the hook: import { useTraceStateWithCounter } from "../hooks/useTraceStateWithCounter";
   - pass the context to track and a string name: useTraceStateWithCounter(context.crossfilterStore, "crossfilterStore"); 
*/

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
  